import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractInputSelect } from '@components/field_form/select-inputs/abstract-input-select';
import { LiveService } from '@services/cms/live.service';
import { AbstractService } from '@services/Abstract.service';

@Component({
  selector: 'app-input-select-live',
  templateUrl: './input-select-live.component.html',
  styleUrls: ['./input-select-live.component.scss']
})
export class InputSelectLiveComponent extends AbstractInputSelect implements OnInit {
  @Input() public serviceModel: AbstractService | null = null;
  @Input() public label = 'store';
  @Input() public name = '';
  @Input() public required = false;
  @Input() public multiple = false;
  @Input() public disabled = false;
  reloadData = true;
  list: any[] = [];
  selectTemporal: any[] = [];
  private isDataLoading = false;
  // Events
  @Output() changeAction = new EventEmitter<any>();
  @Output() loadAction = new EventEmitter<any>();

  constructor(
      public service: LiveService
  ) {
    super(service);
  }

  ngOnInit(): void {
    this.loadData('data');
  }

  public change = () => {
    this.changeAction.emit();
  }
}
